export default function delQProductLine(way, delInd){
    this.dataArrayDelete([{way : way, index : delInd}]);
}